import { Component, Inject, OnInit, ViewChild } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-pay-success-dialog',
    templateUrl: './pay-success-dialog.component.html',
    styleUrls: ['./pay-success-dialog.component.scss'],
    standalone: false
})
export class PaySuccessDialogComponent  {
	$storage: any;

	constructor(
		public appService: AppService,
		public dialogRef: MatDialogRef<PaySuccessDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.$storage = this.data.$storage;
	}


	cancel() {
		this.dialogRef.close();
	}

	apply() {
		this.dialogRef.close({});
	}

	downloadInvoice(ev) {
		if (ev) ev.stopPropagation();
		const order = this.$storage.order;
		window.open(`${this.appService.appConfig.tabitBillURL}/receipt?o=${order.site_id}&oid=${order.order_id}&p=&c=`)
	}

}
